import React from 'react'
import Resx from '@/components/Resx'
import { NotificationItem } from '@/components/notifications/notificationItem'

class WidgetContent extends React.Component {
  render () {
    const { className, items } = this.props
    if (!items.length) {
      return (
        <React.Fragment>
          <div className='d-notification__nothing'><Resx name='NotificationsUI.NoNotifications' /></div>
        </React.Fragment>
      )
    }
    return (
      <div className={className}>
        <div style={{ maxHeight: 250 }}>{items.map(item => <NotificationItem key={item.id} {...item} onRead={this.onReadClick} />)}</div>
      </div>
    )
  }

  onReadClick = e => {
    const { id, state } = e
    this.props.updateState(id, state)
  };
}

export default WidgetContent



// WEBPACK FOOTER //
// ./src/components/notifications/widgetContent.js